export default {
  props: {
    group: {
      type: [Object, Array],
      required: false,
      default: null
    }
  }
}
